import React from "react";
import Tooltip from "@mui/material/Tooltip";
import logo from "../../../Static/images/logo.png";
import NoDataFound from "../../Quiz/NoDataFound/NoDataFound";

const DynamicModuleList = ({ list = [], onModuleClick }) => {
  return (
    <>
      <div className="course-tiles">
        {list?.map((item) => (
          <div key={item.uuid} className="tilecard" onClick={() => onModuleClick(item)}>
            <div className="modulecard module">
              <div className="moduleicon">
                <img
                  src={item?.versions[0]?.data?.thumbnail || logo}
                  className="defaultimg"
                  alt="Default Thumbnail"
                  referrerPolicy="no-referrer"
                />
              </div>
              <div className="moduledata">
                <Tooltip title="Name">
                  <p className="modulename">{item.name}</p>
                </Tooltip>
                <p className="moduledes">{item?.versions[0]?.data?.shortDescription}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
      {list.length === 0 && <NoDataFound text="No data found." />}
    </>
  );
};

export default DynamicModuleList;
